import projects from './http-projects';
import users from './http-users';
import entities from './http-entities';
import intents from './http-intents';
import nodes from './http-nodes';
import anchors from './http-anchors';
import links from './http-links';
import colors from './http-colors';
import chat from './http-chat';
import skills from "./http-skills";

const state = {
  anchors: {
    types: '/anchors/types'
  }
};
const actions = {};
export default {
  namespaced: true,
  state,
  actions,
  modules: {
    projects,
    users,
    entities,
    intents,
    nodes,
    anchors,
    links,
    colors,
    chat,
    skills
  }
};
